import { render } from "./Account.vue?vue&type=template&id=2e7bbf64"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=2e7bbf64&lang=less"
script.render = render

export default script